import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEmptyStateMessages = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 330,
	height: 330,
	viewBox: "0 0 330 330",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_2514_40492)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M149.567 295.268C221.527 295.268 279.862 236.933 279.862 164.973C279.862 93.0128 221.527 34.6776 149.567 34.6776C77.607 34.6776 19.2719 93.0128 19.2719 164.973C19.2719 236.933 77.607 295.268 149.567 295.268Z",
				fill: "#EBF3FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M139.89 118.916L223.271 118.916C234.762 118.916 244.078 109.601 244.078 98.1092V76.0593C244.078 64.5678 234.762 55.2522 223.271 55.2522L139.89 55.2522C128.398 55.2522 119.083 64.5678 119.083 76.0593V98.1092C119.083 109.601 128.398 118.916 139.89 118.916Z",
				fill: "#C2F4F1"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M203.89 117.978C196.072 130.976 183.011 134.047 176.227 134.736C174.752 134.889 173.886 133.109 174.92 132.042C179.699 127.087 181.784 122.188 182.521 117.978H203.898H203.89Z",
				fill: "#C2F4F1"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M97.8504 126.983H62.0173C52.2794 126.983 44.3853 134.877 44.3853 144.615V153.932C44.3853 163.67 52.2794 171.564 62.0173 171.564H97.8504C107.588 171.564 115.482 163.67 115.482 153.932V144.615C115.482 134.877 107.588 126.983 97.8504 126.983Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M68.1258 170.826C73.2253 179.309 81.7486 181.306 86.1747 181.763C87.1369 181.859 87.7061 180.704 87.0326 180.007C83.9136 176.776 82.5585 173.576 82.0774 170.834H68.1338L68.1258 170.826Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M217.121 233.752V246.822H206.063",
				stroke: "#3F8BFD",
				strokeWidth: 8.47495,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M186.13 233.752V246.822H175.065",
				stroke: "#3F8BFD",
				strokeWidth: 8.47495,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M208.388 199.042C201.701 205.729 190.869 205.729 184.182 199.042C177.494 192.355 177.494 181.522 184.182 174.835C190.869 168.148 247.124 136.099 247.124 136.099C247.124 136.099 215.076 192.355 208.388 199.042Z",
				fill: "#3F8BFD",
				stroke: "#3F8BFD",
				strokeWidth: 8.47495,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M247.125 136.099L271.083 245.651H284.778",
				stroke: "#3F8BFD",
				strokeWidth: 8.47495,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M228.595 233.239H167.561V162.631H299.203C299.203 201.624 267.588 233.239 228.595 233.239Z",
				fill: "#9EC5FF",
				stroke: "#9EC5FF",
				strokeWidth: 6.27146,
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M152.06 162.631H167.568V233.239C148.067 233.239 132.232 217.403 132.232 197.903V182.46C132.232 171.516 141.116 162.631 152.06 162.631Z",
				fill: "#6BA6FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M167.559 235.613C146.736 235.613 129.85 218.726 129.85 197.903V182.46C129.85 170.201 139.792 160.258 152.052 160.258H169.933V233.239C169.933 234.554 168.866 235.613 167.559 235.613Z",
				fill: "#C5DCFF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M194.413 162.519H327.627C327.627 182.067 311.759 197.935 292.211 197.935H229.83C210.281 197.935 194.413 182.067 194.413 162.519Z",
				fill: "#6BA6FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M292.21 200.317H229.829C208.958 200.317 192.04 183.399 192.04 162.527C192.04 161.212 193.106 160.154 194.413 160.154H327.627C328.942 160.154 330 161.22 330 162.527C330 183.399 313.082 200.317 292.21 200.317ZM196.875 164.901C198.093 182.019 212.414 195.57 229.837 195.57H292.219C309.642 195.57 323.954 182.019 325.181 164.901H196.883H196.875Z",
				fill: "#6BA6FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M164.168 169.752C164.168 151.166 149.102 136.107 130.523 136.107",
				stroke: "#C5DCFF",
				strokeWidth: 4.23748,
				strokeMiterlimit: 10,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M153.993 170.032C153.993 158.807 144.893 149.706 133.667 149.706",
				stroke: "#C5DCFF",
				strokeWidth: 4.23748,
				strokeMiterlimit: 10,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M245.529 199.042C238.842 205.729 228.01 205.729 221.322 199.042C214.635 192.355 214.635 181.522 221.322 174.835C228.01 168.148 284.265 136.099 284.265 136.099C284.265 136.099 252.216 192.355 245.529 199.042Z",
				fill: "#3F8BFD",
				stroke: "#3F8BFD",
				strokeWidth: 8.47495,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M284.264 136.099L308.23 245.651H321.925",
				stroke: "#3F8BFD",
				strokeWidth: 8.47495,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M69.7872 240.985V247.977H75.7126",
				stroke: "#3F8BFD",
				strokeWidth: 4.12095,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M83.1923 240.985V247.977H89.1097",
				stroke: "#3F8BFD",
				strokeWidth: 4.12095,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M71.2774 222.407C74.8535 225.983 80.6506 225.983 84.2347 222.407C87.8108 218.831 87.8108 213.034 84.2347 209.449C80.6586 205.873 50.5504 188.723 50.5504 188.723C50.5504 188.723 67.7013 218.823 71.2774 222.407Z",
				fill: "#3F8BFD",
				stroke: "#3F8BFD",
				strokeWidth: 4.12095,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M50.5513 188.731L37.7303 247.351H30.4017",
				stroke: "#3F8BFD",
				strokeWidth: 4.12095,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M60.4696 240.704H93.1275V202.923H22.688C22.688 223.786 39.6063 240.704 60.4696 240.704Z",
				fill: "#9EC5FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M94.4027 241.979H60.4698C38.9331 241.979 21.4134 224.46 21.4134 202.923V201.656H94.3947V241.979H94.4027Z",
				fill: "#9EC5FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M93.1276 240.704V202.923H101.426C107.28 202.923 112.034 207.678 112.034 213.531V221.798C112.034 232.229 103.559 240.704 93.1276 240.704Z",
				fill: "#6BA6FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M93.1284 241.979C104.274 241.979 113.31 232.943 113.31 221.797V213.531C113.31 206.972 107.994 201.648 101.427 201.648H91.8615V240.704C91.8615 241.41 92.4308 241.971 93.1284 241.971V241.979Z",
				fill: "#C5DCFF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M59.8044 221.822H26.4248C15.9611 221.822 7.46988 213.33 7.46988 202.867H78.7593C78.7593 213.33 70.2681 221.822 59.8044 221.822Z",
				fill: "#6BA6FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M26.4238 223.088H59.8034C70.9727 223.088 80.0252 214.036 80.0252 202.867C80.0252 202.161 79.4559 201.6 78.7583 201.6H7.46883C6.76324 201.6 6.20197 202.169 6.20197 202.867C6.20197 214.036 15.2545 223.088 26.4238 223.088Z",
				fill: "#6BA6FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M94.9392 206.731C94.9392 196.789 102.997 188.723 112.948 188.723",
				stroke: "#C5DCFF",
				strokeWidth: 2.57427,
				strokeMiterlimit: 10,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M100.392 206.884C100.392 200.878 105.259 196.003 111.273 196.003",
				stroke: "#C5DCFF",
				strokeWidth: 2.57427,
				strokeMiterlimit: 10,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M51.409 222.407C54.9851 225.983 60.7822 225.983 64.3664 222.407C67.9425 218.831 67.9425 213.034 64.3664 209.449C60.7903 205.873 30.6821 188.723 30.6821 188.723C30.6821 188.723 47.8329 218.823 51.409 222.407Z",
				fill: "#3F8BFD",
				stroke: "#3F8BFD",
				strokeWidth: 4.12095,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M30.6813 188.731L17.8523 247.351H10.5237",
				stroke: "#3F8BFD",
				strokeWidth: 4.12095,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M63.9417 251.336H110.928C111.594 251.336 112.131 250.799 112.131 250.134C112.131 249.468 111.594 248.931 110.928 248.931H63.9417C63.2762 248.931 62.739 249.468 62.739 250.134C62.739 250.799 63.2762 251.336 63.9417 251.336Z",
				fill: "#9EC5FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M46.2938 251.336H93.2802C93.9457 251.336 94.4829 250.799 94.4829 250.134C94.4829 249.468 93.9457 248.931 93.2802 248.931H46.2938C45.6283 248.931 45.0911 249.468 45.0911 250.134C45.0911 250.799 45.6283 251.336 46.2938 251.336Z",
				fill: "#9EC5FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6.81167 251.336H33.7286C34.3941 251.336 34.9314 250.799 34.9314 250.134C34.9314 249.468 34.3941 248.931 33.7286 248.931H6.81167C6.14616 248.931 5.60895 249.468 5.60895 250.134C5.60895 250.799 6.14616 251.336 6.81167 251.336Z",
				fill: "#9EC5FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M291.4 251.336H318.317C318.982 251.336 319.52 250.799 319.52 250.134C319.52 249.468 318.982 248.931 318.317 248.931H291.4C290.734 248.931 290.197 249.468 290.197 250.134C290.197 250.799 290.734 251.336 291.4 251.336Z",
				fill: "#9EC5FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M254.261 251.336H281.178C281.843 251.336 282.38 250.799 282.38 250.134C282.38 249.468 281.843 248.931 281.178 248.931H254.261C253.595 248.931 253.058 249.468 253.058 250.134C253.058 250.799 253.595 251.336 254.261 251.336Z",
				fill: "#9EC5FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M123.292 251.336H262.183C262.848 251.336 263.385 250.799 263.385 250.134C263.385 249.468 262.848 248.931 262.183 248.931H123.292C122.627 248.931 122.089 249.468 122.089 250.134C122.089 250.799 122.627 251.336 123.292 251.336Z",
				fill: "#9EC5FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M140.939 175.581C140.37 175.581 139.913 176.046 139.921 176.607C139.921 177.168 139.464 177.633 138.902 177.633C138.606 177.617 138.373 177.529 138.173 177.337C137.98 177.144 137.868 176.888 137.868 176.615C137.868 176.054 137.403 175.597 136.842 175.597C136.272 175.597 135.815 176.062 135.823 176.623C135.823 177.449 136.152 178.219 136.729 178.796C137.307 179.373 138.076 179.686 138.894 179.686H138.91C140.602 179.686 141.981 178.291 141.973 176.599C141.973 176.038 141.508 175.581 140.947 175.581H140.939Z",
				fill: "#6BA6FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M156.318 175.581C155.749 175.581 155.292 176.046 155.3 176.607C155.3 177.168 154.843 177.633 154.282 177.633C154.009 177.633 153.752 177.529 153.56 177.337C153.368 177.144 153.255 176.888 153.255 176.615C153.255 176.054 152.79 175.597 152.229 175.597C151.66 175.597 151.203 176.062 151.211 176.623C151.211 177.449 151.539 178.219 152.117 178.796C152.694 179.373 153.464 179.686 154.282 179.686H154.298C155.998 179.686 157.369 178.291 157.361 176.599C157.361 176.038 156.896 175.581 156.334 175.581H156.318Z",
				fill: "#6BA6FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M149.108 187C148.538 187 148.081 187.465 148.089 188.026C148.089 188.588 147.632 189.053 147.071 189.053C146.798 189.053 146.542 188.948 146.349 188.756C146.157 188.564 146.045 188.307 146.045 188.034C146.045 187.473 145.58 187.016 145.018 187.016C144.449 187.016 143.992 187.481 144 188.042C144 188.868 144.329 189.638 144.906 190.215C145.483 190.793 146.253 191.105 147.071 191.105H147.087C148.787 191.105 150.158 189.71 150.15 188.018C150.15 187.457 149.685 187 149.124 187H149.108Z",
				fill: "#6BA6FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M98.2594 209.706C98.2594 209.017 97.7062 208.447 97.0086 208.447C96.319 208.447 95.7498 209.001 95.7498 209.698C95.7498 210.388 96.303 210.957 97.0006 210.957C97.6902 210.957 98.2594 210.404 98.2594 209.706Z",
				fill: "#6BA6FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M107.665 209.706C107.665 209.017 107.112 208.447 106.414 208.447C105.725 208.447 105.155 209.001 105.155 209.698C105.155 210.388 105.709 210.957 106.406 210.957C107.096 210.957 107.665 210.404 107.665 209.706Z",
				fill: "#6BA6FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M104.108 213C103.538 213 103.081 213.465 103.089 214.026C103.089 214.588 102.632 215.053 102.071 215.053C101.798 215.053 101.542 214.948 101.349 214.756C101.157 214.564 101.045 214.307 101.045 214.034C101.045 213.473 100.58 213.016 100.018 213.016C99.4491 213.016 98.9921 213.481 99.0001 214.042C99.0001 214.868 99.3289 215.638 99.9062 216.215C100.483 216.793 101.253 217.105 102.071 217.105H102.087C103.787 217.105 105.158 215.71 105.15 214.018C105.15 213.457 104.685 213 104.124 213H104.108Z",
				fill: "#6BA6FF"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_2514_40492",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 330,
			height: 330,
			fill: "white"
		})
	}) })]
});
export default SvgEmptyStateMessages;
